import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { DashboardLayoutComponent } from '@syncfusion/ej2-react-layouts';
import UserList from './User List/UserList';
import TempPanel from './Dashboard Panels/TempPanel';
// import WhiteBoard from './Dashboard Panels/whiteBoard';
import DataPanel from './Dashboard Panels/DataPanel';
import Spreadsheet from './Dashboard Panels/Spreadsheet/spreadsheet';
import Chatbot from './Dashboard Panels/Chatbot/chatbot';
import ConversationView from './ConversationView/ConversationView';
import './main.css';
import { createPortal } from 'react-dom';
import ConversationObserver from './Dashboard Panels/Observer/observer';
import ImavenLoadingScreen from './Helpers/loading-screen';
import { useParams } from 'react-router-dom';
import TextEditor from './Dashboard Panels/TextEditor/textEditor';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import ResizeIcon from '../../src/Images/resize.svg';
import FloatIcon from '../../src/Images/float.svg';
import DragIcon from '../../src/Images/drag.svg';
import ConversationIcon from '../../src/Images/conversation.svg';
import ChatbotIcon from '../../src/Images/chatbot.svg';
import ObserverIcon from '../../src/Images/observer.svg';
import EditorIcon from '../../src/Images/editor.svg';
import styled from 'styled-components';

const PanelPortal = ({ children, containerId }) => {
  const container = document.getElementById(containerId);
  return container ? createPortal(children, container) : null;
};

const DashboardContainer = styled.div`
  width: 100%;
  overflow: hidden;
  min-height: 100%;
  

  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
  &::-webkit-scrollbar {
    display: none;           /* Chrome, Safari and Opera */
  }

  /* Custom scrollbar for the entire dashboard */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: #0f1419;
    border-radius: 10px;
  }

  *::-webkit-scrollbar-thumb {
    background: rgba(100, 150, 200, 0.2);
    border-radius: 10px;
    border: 2px solid #0f1419;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: rgba(100, 150, 200, 0.35);
  }

  /* For corner where vertical and horizontal scrollbars meet */
  *::-webkit-scrollbar-corner {
    background: #0f1419;
  }

  /* Add these new styles for the control buttons */
  .control-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px;
    margin: 8px 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
    
  }

  .control-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .control-button img {
    width: 20px;
    height: 20px;
    transition: filter 0.2s;
  }

  .control-button img.disabled {
    filter: grayscale(100%) brightness(70%);
  }

  .control-button img.enabled {
    filter: invert(73%) sepia(88%) saturate(1095%) hue-rotate(325deg) brightness(101%) contrast(96%);
  }
  
  /* New responsive styles for the dashboard layout */
  .e-dashboard-layout .e-panel {
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    margin: 8px !important;
    box-sizing: border-box !important;
  }
  
  .e-dashboard-layout .e-panel .e-panel-container,
  .e-dashboard-layout .e-panel .e-panel-container .e-panel-content {
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
  }
  
  .e-dashboard-layout .e-panel .e-panel-container .e-panel-content > div {
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box !important;
    overflow: auto !important;
  }
  
  /* Responsive styling for small screens */
  @media screen and (max-width: 1024px) {
    .e-dashboard-layout .e-panel {
      margin: 4px !important;
    }
    
    .e-panel .e-panel-container {
      overflow: auto !important;
    }
    
    #default_target, .dashboardParent {
      padding: 4px !important;
    }
  }
  
  @media screen and (max-width: 768px) {
    #default_dashboard {
      padding: 0 !important;
    }
    
    .e-dashboard-layout .e-panel {
      margin: 2px !important;
    }
    
    #default_target, .dashboardParent {
      padding: 2px !important;
    }
  }
`;

const Main = ({ allowResizing, allowDragging, allowFloating }) => {
  const { user, getAccessTokenSilently, isAuthenticated } = useAuth0();
  const { threadId } = useParams();

  const dashboardObj = useRef(null);

  const [count, setCount] = useState(0);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [activePanels, setActivePanels] = useState([]);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [editorCommands, setEditorCommands] = useState(null);
  const [isHighResolution, setIsHighResolution] = useState(window.innerWidth > 1920 || window.innerHeight > 1080);

  const cellSpacing = [12, 12];

  // Add window resize handler to properly adjust layout
  useEffect(() => {
    const handleResize = () => {
      // Update resolution state
      setIsHighResolution(window.innerWidth > 1920 || window.innerHeight > 1080);
      
      if (dashboardObj.current) {
        // Set a fixed height based on viewport
        const viewportHeight = window.innerHeight;
        const dashboardElement = document.getElementById('default_dashboard');
        
        if (dashboardElement) {
          // Set fixed heights at breakpoints to prevent jumping
          if (window.innerWidth <= 768) {
            dashboardElement.style.height = '700px';
          } else if (window.innerWidth <= 992) {
            dashboardElement.style.height = '800px';
          } else if (window.innerWidth <= 1200) {
            dashboardElement.style.height = '800px';
          } else {
            dashboardElement.style.height = '800px';
          }
          
          // Force refresh layout with a slight delay to ensure rendering is complete
          setTimeout(() => {
            resetPanelPositions();
          }, 50);
        }
      }
    };

    // Initial resize
    handleResize();
    
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [selectedConversation, activePanels]);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        if (isAuthenticated && user) {
          const token = await getAccessTokenSilently();

          const response = await axios.get(`${process.env.REACT_APP_SERVER}userConversation`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          if (response.status === 200) {
            setConversations(response.data);
            if (threadId) {
              setLoadingFlag(true)
              setTimeout(async () => {
                const convo = response.data.filter(x => x.threadId == threadId);

                const res = await axios.get(`${process.env.REACT_APP_SERVER}conversations/${threadId}`, {
                  headers: {
                    Authorization: `Bearer ${token}`
                  }
                });

                if (res.status == 200) {
                  handleConversationSelect(res.data, convo[0].id)
                } else {
                  throw new Error('No conversation found')
                }

              }, 1)
            }
          } else {
            console.error('Failed to fetch conversations', response.statusText);
          }
        }
      } catch (error) {
        console.error('Error fetching conversations:', error);
      }
    };

    fetchConversations();
  }, [isAuthenticated, user, getAccessTokenSilently]);

  const onCloseIconHandler = (event) => {
    let panel = event.target;
    if (panel.offsetParent) {
      dashboardObj.current.removePanel(panel.offsetParent.id);
    }
  };

  const btnClick = (component, sizeX = 1, sizeY = 1, row = 0, col = 0, headerName = "Header") => {
    setCount(prevCount => prevCount + 1);

    let panelId = `${count + 1}_layout`;
    let panel = [{
      'id': panelId, 'sizeX': sizeX, 'sizeY': sizeY, 'row': row, 'col': col,
      header: `<div class="e-header-text">${headerName}</div><div class="header-border"></div>`,
      content: `<span id="close" class="e-close-icon e-clear-icon"></span>
      <div id="panel-content-${panelId}" class="text-align"></div>`
    }];

    dashboardObj.current.addPanel(panel[0]);

    // let closeIcon = document.getElementById(panelId).querySelector('.e-clear-icon');
    // closeIcon.addEventListener('click', onCloseIconHandler.bind(this));

    // Dynamically render the component into the panel
    let container = document.getElementById(`panel-content-${panelId}`);
    if (container) {
      ReactDOM.render(component, container);
    }
  };

  const updateConversationViaSocket = (Updatedconversation) => {
    debugger;
    console.log(conversations);
    setConversations((prev) => {
      prev.map(item => {
        if (item.threadId == Updatedconversation.threadId) {
          item.messages = Updatedconversation.messages
        }
      });
    });
  }

  const handleConversationSelect = (conversation, userId) => {
    // Clear existing panels
    if (dashboardObj == null)
      return;

    setLoadingFlag(false);

    setSelectedConversation(conversation);
    dashboardObj.current.removeAll();

    // Define panel layout with responsive sizing
    const panelSizeY = isHighResolution ? 3.79 : 3.5;
    
    const panels = [
      { 
        id: 'conversation_panel',
        sizeX: 4, sizeY: 4, 
        row: 0, col: 0, 
        content: (id) => <ConversationView conversation={conversation} userId={userId} setConversation={updateConversationViaSocket} />,
        header: {
          icon: ConversationIcon,
          title: "Conversation",
          bgColor: "#363636",
          style: "background-color:rgb(46 48 52) !important; border-bottom: 1px solid rgba(255, 255, 255, 0.1);"
        }
      },
      { 
        id: 'chatbot_panel',
        sizeX: 2, sizeY: isHighResolution ? 3.79 : 3.5, 
        row: 4, col: 4, 
        content: (id) => <Chatbot threadId={conversation.threadId} />,
        header: {
          icon: ChatbotIcon,
          title: "Chatbot",
          bgColor: "#363636",
          style: "background-color:rgb(46 48 52) !important; border-bottom: 1px solid rgba(255, 255, 255, 0.1);"
        }
      },
      { 
        id: 'observer_panel',
        sizeX: 1.8,
        sizeY:4, 
        row: 0, col: 4, 
        content: (id) => <ConversationObserver observerId={conversation.observerId} />,
        header: {
          icon: ObserverIcon,
          title: "Observer",
          bgColor: "#363636",
          smallHeader: false,
          style: "background-color:rgb(46 48 52) !important; border-top-left-radius: 8px; border-top-right-radius: 8px; border-bottom: 1px solid rgba(255, 255, 255, 0.1);"
        }
      },
      { 
        id: 'editor_panel',
        sizeX: 4, 
        sizeY: isHighResolution ? 3.79 : 3.5, 
        row: 4, col: 0, 
        content: (id) => <TextEditor onInit={(commands) => setEditorCommands(commands)} threadId={conversation._id} />,
        header: {
          icon: EditorIcon,
          title: "Conversation Overview & Recommendations",
          bgColor: "#363636",
          style: "background-color:rgb(46 48 52) !important; border-bottom: 1px solid rgba(255, 255, 255, 0.1);"
        }
      }
    ];

    const newPanels = [];

    // Add panels with fixed layout
    panels.forEach((panel, index) => {
      const panelId = `${panel.id}_${index}`;
      
      // Create panel with header
      const headerStyle = panel.header.smallHeader 
        ? `padding: 6px 10px; display: flex; align-items: center; background: ${panel.header.bgColor}; height: 42px; ${panel.header.style || ''}`
        : `padding: 10px; display: flex; align-items: center; background: ${panel.header.bgColor}; height: 42px; ${panel.header.style || ''}`;
        
      const headerTextStyle = panel.header.smallHeader
        ? `font-weight: 500; color: white; font-size: 12px;`
        : `font-weight: 500; color: white;`;
        
      const iconSize = panel.header.smallHeader
        ? `width: 16px; height: 16px; margin-right: 6px;`
        : `width: 20px; height: 20px; margin-right: 8px;`;
      
      // Use special handling for observer panel to prevent artifacts
      const isObserver = panel.id.includes('observer');
      const customStyle = isObserver ? 'border-radius: 8px; overflow: hidden;' : '';
      
      // Add to dashboard
      dashboardObj.current.addPanel({
        'id': panelId,
        'sizeX': panel.sizeX,
        'sizeY': panel.sizeY,
        'row': panel.row,
        'col': panel.col,
        'minSizeX': 2,
        'minSizeY': 1,
        'allowDragging': false,
        'allowResizing': false,
        'showHeader': false,
        cssClass: 'custom-panel panel-no-hover',
        content: `
          <div style="height: 100%; display: flex; flex-direction: column; background: linear-gradient(145deg, #0f1419 0%, #1a1f2e 100%); ${customStyle}">
            <div class="panel-header" style="${headerStyle}">
              <img src="${panel.header.icon}" alt="${panel.header.title}" style="${iconSize} filter: invert(1);"/>
              <span style="${headerTextStyle}">${panel.header.title}</span>
            </div>
            <div id="panel-content-${panelId}" class="text-align" style="flex: 1; background: linear-gradient(180deg, #0f1419 0%, #141a23 100%);"></div>
          </div>
        `
      });
      
      // Store for rendering components
      newPanels.push({
        id: `panel-content-${panelId}`,
        component: panel.content(`panel-content-${panelId}`)
      });
    });

    setActivePanels(newPanels);
  };

  // Function to reset panel positions when window is resized
  const resetPanelPositions = () => {
    if (!dashboardObj.current || !selectedConversation || activePanels.length < 1) return;
    
    dashboardObj.current.refresh();
  };

  const items = [
    { text: 'Temporary Panel', id: <TempPanel />, header: "Temporary Panel" },
    { text: 'Data Panel', id: <DataPanel />, header: "Data Panel" },
    { text: 'Spreadsheet', id: <Spreadsheet />, header: "Spreadsheet" },
    { text: 'Chatbot', id: <Chatbot />, header: "ChatBot" },
  ];

  const loadingConversationData = () => {
    setLoadingFlag(!loadingFlag);
  }

  const formatItems = [
    {
      text: 'Text Formatting',
      items: [
        { text: 'Bold', id: 'bold', iconCss: 'e-icons e-bold' },
        { text: 'Italic', id: 'italic', iconCss: 'e-icons e-italic' },
        { text: 'Underline', id: 'underline', iconCss: 'e-icons e-underline' },
      ]
    },
    {
      text: 'Alignment',
      items: [
        { text: 'Left Align', id: 'justifyLeft' },
        { text: 'Center', id: 'justifyCenter' },
        { text: 'Right Align', id: 'justifyRight' },
      ]
    },
    {
      text: 'Lists',
      items: [
        { text: 'Bullet List', id: 'insertUnorderedList' },
        { text: 'Number List', id: 'insertOrderedList' },
      ]
    },
    {
      text: 'Clear Formatting', id: 'removeFormat'
    }
  ];

  const handleFormatSelect = (e) => {
    if (editorCommands && e.item.id) {
      editorCommands.execCommand(e.item.id);
    }
  };

  // Update the useEffect to only use the props
  useEffect(() => {
    if (dashboardObj.current) {
      dashboardObj.current.allowResizing = allowResizing;
      dashboardObj.current.allowDragging = allowDragging;
      dashboardObj.current.allowFloating = allowFloating;
    }
  }, [allowResizing, allowDragging, allowFloating]);

  return (
    <DashboardContainer>
      <div id="default_target" className="control-section" style={{ height: '100%', overflow: 'hidden' }}>
        <div style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          background: 'linear-gradient(180deg, #0a0d12 0%, #0f1419 50%, #141a23 100%)',
          overflow: 'hidden',
          paddingTop: '5px'
        }}>
          <div style={{ width: "24%", minWidth: "380px", flexShrink: 0 }}>
            <UserList
              conversationsInit={conversations}
              clientId={user?.sub}
              onConversationSelect={handleConversationSelect}
              loadingData={loadingConversationData}
              threadIdParam={threadId}
            />
          </div>
          <div style={{
            width: "76%",
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            position: 'relative'
          }}>
            {loadingFlag && (
              <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <ImavenLoadingScreen></ImavenLoadingScreen>
              </div>
            )}
            <div className="dashboardParent" style={{
              width: '100%',
              height: '100%',
              position: 'relative',
              overflow: 'auto',
              padding: '8px',
              scrollbarWidth: 'none', /* Firefox */
              msOverflowStyle: 'none', /* IE and Edge */
            }}>
              <style>
                {`
                  .dashboardParent::-webkit-scrollbar {
                    display: none; /* Chrome, Safari and Opera */
                  }
                `}
              </style>
              <DashboardLayoutComponent
                id="default_dashboard"
                columns={6.05}
                ref={dashboardObj}
                cellAspectRatio={2.1}
                cellSpacing={[6, 6]}
                allowResizing={false}
                allowDragging={false}
                allowFloating={false}
                mediaQuery={true}
                resizeStop={(args) => {
                  args.element.style.height = args.element.offsetHeight + "px";
                }}
                created={() => {
                  // Set initial state after creating
                  const dashboardElement = document.getElementById('default_dashboard');
                  if (dashboardElement) {
                    dashboardElement.style.height = 'auto';
                    dashboardElement.style.minHeight = '900px';
                  }
                }}
                cssClass="e-dark-theme"
                style={{
                  background: 'transparent',
                  height: 'auto',
                  minHeight: '900px',
                  width: '100%',
                  boxSizing: 'border-box',
                  margin: '0 auto'
                }}
              >
                {activePanels.map(panel => (
                  <PanelPortal key={panel.id} containerId={panel.id}>
                    {panel.component}
                  </PanelPortal>
                ))}
              </DashboardLayoutComponent>
            </div>
          </div>
        </div>
      </div>
    </DashboardContainer>
  );
};

export default Main;
